// Presentation only: never write this value back to contacts or message bodies.
export const customerDisplayName = (value?: string): string =>
 (value ?? '').toLocaleLowerCase('es').replace(/(^|[^\p{L}\p{M}])(\p{L})/gu,
  (_match, separator, letter) => separator + letter.toLocaleUpperCase('es'));
